import { Icon, IconButton, Tooltip } from '../../../../../../base';
import { StyledActionButtonsContainer } from '../../JobQuestions.styles';
import { useTranslation } from 'react-i18next';

interface QuestionActionButtonsProps {
    onCopy: () => void;
    onDelete: () => void;
}

export const QuestionActionButtons = ({
    onCopy,
    onDelete,
}: QuestionActionButtonsProps) => {
    const { t } = useTranslation();

    return (
        <StyledActionButtonsContainer>
            <Tooltip title={t('saveJob.copyQuestion')}>
                <IconButton
                    onClick={onCopy}
                    size="small"
                    aria-label={t('saveJob.copyQuestion')}
                    sx={{ padding: '4px' }}
                >
                    <Icon name="ContentCopyOutlinedIcon" sx={{ fontSize: 20 }} />
                </IconButton>
            </Tooltip>
            <Tooltip title={t('saveJob.deleteQuestion')}>
                <IconButton
                    onClick={onDelete}
                    size="small"
                    aria-label={t('saveJob.deleteQuestion')}
                    sx={{ padding: '4px' }}
                >
                    <Icon name="DeleteIcon" sx={{ fontSize: 20 }} />
                </IconButton>
            </Tooltip>
        </StyledActionButtonsContainer>
    );
};

